/**
 * 인증쿠키 (HttpOnly) 가 자동 첨부되도록 동일 origin url 을 hidden anchor 로 트리거.
 * Content-Disposition: attachment 헤더는 백엔드가 설정.
 */
export function triggerDownload(url: string): void {
  const a = document.createElement('a')
  a.href = url
  a.rel = 'noopener'
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  a.remove()
}
